import { render } from "./MerchantLogin.vue?vue&type=template&id=1f7ae186&scoped=true"
import script from "./MerchantLogin.vue?vue&type=script&lang=js"
export * from "./MerchantLogin.vue?vue&type=script&lang=js"

import "./MerchantLogin.vue?vue&type=style&index=0&id=1f7ae186&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7ae186"]])

export default __exports__